/** Transient success toast. Colour (bed-good) is paired with a check icon
 * AND the word "Saved" — colour is never the only signal (CLAUDE.md a11y). */
export function SaveToast({ time }: { time: string }) {
  return (
    <div
      role="status"
      className="fixed bottom-6 right-6 inline-flex items-center gap-2 rounded-[8px] border border-bed-good/30 bg-bed-good-bg px-3 py-2 text-sm font-medium text-bed-good shadow-sm"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m5 12 5 5L20 7" />
      </svg>
      <span>Saved · {time}</span>
    </div>
  )
}
